import Vuex from "vuex";
import Vue from "vue";

import axios from "axios";

Vue.use(Vuex);

import * as types from "../store/types";
import StaticData from "./static-data";
import actions from "./actions";
import mutations from "./mutations";

export default new Vuex.Store({
  state: {
    searchResultsLoading: false,
    searchResults: {
      page: 0,
      items: []
    },

    placeDetailsLoading: false,
    fetchedPlaceDetails: null,

    fetchedFAQ: null,
    isFAQLoading: true,

    selectedState: null,
    selectedCategory: 0,
    selectedLocation: null,

    registerFormSubmitting: false,
    registerFormSubmitResult: null,

    messageFormSubmitting: false,
    messageFormSubmitResult: null,

    // Static Data -------------

    staticCities: StaticData.staticCities,
    staticStates: StaticData.staticStates,
    staticCategories: StaticData.staticCategories,

    staticPlaceFeatures: Object.freeze([
      { id: 1, name: "Atención en Tienda" },
      { id: 2, name: "Despacho a Domicilio" },
      { id: 3, name: "Pago On-line y Retiro en Tienda" },
      { id: 4, name: "Pago On-line y Despacho a Domicilio" },

    ]),

    weekDayNames: StaticData.weekDayNames,

    openCloseTimes: StaticData.openCloseTimes
  },

  mutations,
  actions,

  getters: {
    getCities: (state) => (stateId: number) => {
      return state.staticCities.filter( (city) => {
        return city.value.stateId === stateId;
      })
    }
  }
});
